import { useMemo } from "react";

import { isSaasDistribution, isSelfHostedDistribution } from "utils/distribution";
import { MainNavigationGroupItem } from "components/MainNavigation/types";
import { User } from "components/icons/generated";
import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";
import useAvailableLogins from "shared/User/useAvailableLogins";

import {
  MAIN_NAVIGATION_SECONDARY_MENU_ITEMS,
  MainNavigationSecondaryMenuItemKeys,
} from "./menuItemsSecondary";
import useSettingsMenuItems from "./useSettingsMenuItem";

const isSaas = isSaasDistribution();
const isSelfHosted = isSelfHostedDistribution();

export const USER_DROPDOWN_GROUP_ID = "user-dropdown";

const useUserDropdownGroup = (): MainNavigationGroupItem => {
  const { accountName } = useTypedContext(AccountContext);
  const { hasAvailableLogins } = useAvailableLogins({ accountName });

  const { accountSettingsMenuItem } = useSettingsMenuItems();

  const isChangeAccountAvailable = !isSelfHosted && hasAvailableLogins;

  const changeAccountSection = useMemo(
    () =>
      isChangeAccountAvailable
        ? [
            {
              title: "",
              items: [
                // FYI: Menu item has own custom implementation
                // see LoginListNew
                MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
                  MainNavigationSecondaryMenuItemKeys.ChangeAccount
                ],
              ],
            },
          ]
        : [],
    [isChangeAccountAvailable]
  );

  const statusMenuItem = useMemo(
    () =>
      isSaas
        ? [MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.Status]]
        : [],
    []
  );

  const organizationSettingsMenuItem = useMemo(
    () =>
      accountSettingsMenuItem
        ? [
            {
              ...accountSettingsMenuItem,
              title: "Organization settings",
            },
          ]
        : [],
    [accountSettingsMenuItem]
  );

  return useMemo(
    () => ({
      id: USER_DROPDOWN_GROUP_ID,
      title: "User dropdown",
      icon: User,
      items: [
        ...changeAccountSection,
        {
          title: "",
          items: [
            ...organizationSettingsMenuItem,
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.PersonalSettings
            ],
            // FYI: Menu item has own custom implementation
            // see AccountDetailsMenuItem
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.AccountDetails
            ],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.MissionControl
            ],
          ],
        },
        {
          title: "",
          items: [
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.About],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.Privacy],
            ...statusMenuItem,
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.Terms],
          ],
        },
        {
          title: "",
          items: [MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.Logout]],
        },
      ],
    }),
    [changeAccountSection, statusMenuItem, organizationSettingsMenuItem]
  );
};

export default useUserDropdownGroup;
